import { camelcaseKeys } from 'src/utils/camelize-keys';

import { PlanAssignment, WorkoutPlan, WorkoutPlanSearchResult } from './_types';

export function normalizePlanAssignment(assignment: any): PlanAssignment {
  return camelcaseKeys(assignment, { deep: true });
}

export function normalizeWorkoutPlan(workoutPlan: any): WorkoutPlan {
  return camelcaseKeys(workoutPlan, { deep: true });
}

export function normalizeWorkoutPlanSearchResult(
  result: any
): WorkoutPlanSearchResult {
  const { json } = result.data;
  const camelized = camelcaseKeys(json);
  const searchResult: WorkoutPlanSearchResult = {
    id: camelized.id,
    name: result.term,
    aliases: result.aliases,
  };

  return searchResult;
}
